import React from 'react';
import './style.scss';

interface Props {
    currentMode: 1 | 2;
    setCurrentMode: React.Dispatch<1 | 2>;
    content: {1: React.ReactElement | string, 2: React.ReactElement | string};
    label?: string;
    className?: string;
}

const Switch: React.FC<Props> = (props) => {
  const {
    currentMode, setCurrentMode, label, content, className,
  } = props;
  return (
    <div className={`w-100 h-100 ${className}`}>
      <div className={label ? 'label' : 'd-none'}>{label}</div>
      <div className="steppers-switch-container">
        <button
          type="button"
          className={`steppers-switch-left ${currentMode === 1 ? 'active-steppers-switch' : ''}`}
          onClick={() => setCurrentMode(1)}
        >
          {content['1']}
        </button>
        <button
          type="button"
          className={`steppers-switch-right ${currentMode === 2 ? 'active-steppers-switch' : ''}`}
          onClick={() => setCurrentMode(2)}
        >
          <span>{content['2']}</span>
        </button>
      </div>
    </div>
  );
};

export default Switch;
